import { IconName } from '@ui/elements/Icon'
import { ToastVariant } from './types'
import { colors } from '@ui/colors'
import { GradientType } from '@ui/types'
import { hex } from '@ui/utils/hex'

export const iconBy: Record<ToastVariant, IconName> = {
  error: 'exclamation-circle',
  success: 'circle-check-filled',
  warning: 'alert-triangle',
  info: 'info-circle',
}

export const colorBack: Record<ToastVariant, GradientType> = {
  error: [colors.white50, colors.white25, colors.red25],
  success: [colors.white50, colors.white25, colors.green25],
  warning: [colors.white50, colors.white25, colors.amber25],
  info: [colors.white50, colors.white25, colors.blue25],
}

export const colorFront: Record<ToastVariant, string> = {
  error: colors.red[600],
  success: colors.green[600],
  warning: colors.amber[600],
  info: colors.blue[600],
}

export const colorBorder: Record<ToastVariant, string> = {
  error: colors.red[600],
  success: colors.green[600],
  warning: colors.amber[600],
  info: colors.blue[600],
}

export const borderRadius = 24
